// extracted by mini-css-extract-plugin
module.exports = {"loader_wrap":"Loader_loader_wrap__sPqLq","loader":"Loader_loader__Ne8_J","fullScreen":"Loader_fullScreen__LFbak"};